export default function (error) {
  let errorObj
  if (typeof error === 'string') {
    errorObj = new Error(error)
  } else if (typeof error === 'object' && error.message) {
    errorObj = error
  } else {
    errorObj = new Error('Incorrectly configured log')
  }

  if (window.appDebug) {
    window.console.error(errorObj)
  }
  window.newrelic.noticeError(errorObj)
}

export const triggerNewRelicError = (error) => {
  if (window.newrelic && error) {
    window.newrelic.noticeError(error)
  }
}
